import React from 'react';
import { Anchor, Icons } from '@mirohq-internal/website-ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AppStoreBadges = function AppStoreBadges() {
  return /*#__PURE__*/_jsxs("div", {
    className: "d-flex gap-200",
    children: [/*#__PURE__*/_jsx(Anchor, {
      href: "https://apps.apple.com/us/app/miro-collaborative-whiteboard/id1180074773?from=footer_menu&source=miro_website",
      title: "App Store",
      children: /*#__PURE__*/_jsx(Icons.AppleAppStoreBadge, {
        size: "lg"
      })
    }), /*#__PURE__*/_jsx(Anchor, {
      href: "https://play.google.com/store/apps/details?id=com.realtimeboard&from=footer_menu&source=miro_website",
      title: "Google Play",
      children: /*#__PURE__*/_jsx(Icons.GooglePlayStoreBadge, {
        size: "lg"
      })
    })]
  });
};